import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import BgImg from "../../assets/images/background.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundImage: `url(${BgImg})`,
      height: "100vh",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
  }),
);

const useGuestPageContainer = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useGuestPageContainer as default };
